<template>
    <div class="aha-sc-form-container" :id="uuid">
        <!-- <aha-loading-spinner :is-loading="isLoading" /> -->
        <!-- <div class="loader">Loading...</div> -->
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <slot name="default"></slot>
    </div>
</template>
<script>
import { browserDetails } from '../utils/aha-utils';
import idMixin from '@/mixins/aha-id';
import ahaLoadingSpinner from "./aha-loading-spinner.vue";
const browser = browserDetails();
export default {
    components: {
        "aha-loading-spinner": ahaLoadingSpinner,
    },
    mixins: [ idMixin ],
    data() {
        return {
            isValid: false,
            submitButton: null,
            form: null,
            emailInput: null,
            emailFormat: RegExp(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$/),
            isEmailFormatted: null,
            pagePosition: null,
            uuid: null,
            isLoading: false,
            spinnerEl: null
        }
    },
    methods: {
        
        a11yInjection() {
            const errorBoxes = this.$el.querySelectorAll('form .field-validation-error');
            for(const errorBox of errorBoxes) {
                errorBox.style.display = 'none';
                errorBox.setAttribute('role', 'alert');
                errorBox.setAttribute('aria-atomic', 'true');
            }
        },
        isEmailFormatValid() {
            return this.isEmailFormatted = this.emailFormat.test(this.emailInput.value);
            
        },
        isFormValid() {
            if(this.form.checkValidity() === false) {
                return false;
            } else if(this.form.checkValidity() === true && this.isEmailFormatValid() === true) {
                return true;
            }
        },
        onSubmitClicked() {
            // this.pagePosition = window.scrollY;
            // window.__scrollY__ = this.pagePosition;
            setTimeout(() => {
                this.submitButton.disabled = true;
            }, 250);
            this.isLoading = true;
            // console.log("Spinner El");
            // console.log(this.spinnerEl);
            // this.spinnerEl.classList.remove('d-none');
            // this.spinnerEl.classList.add('d-inline-block');
            this.submitButton.value = "Submitting";
        }
    },
    created() {
        
        
        
    },
    mounted() {
        this.uuid = this.safeId('_AHA_sc_form_wrapper_');
        this.a11yInjection();
        this.submitButton = this.$el.querySelector('[type="submit"]');
        this.submitButton.disabled = true;
        // let spinnerEl = document.createElement('div');
        // spinnerEl.classList.add('loader', 'd-none');
        // spinnerEl.innerText = "Loading...";
        // spinnerEl.innerHTML = `<div class="loader d-none ">Loading...</div>`;
        // this.spinnerEl = spinnerEl;
        // this.submitButton.after(spinnerEl);
        this.form =  this.$el.querySelector('form[data-sc-fxb]');
        // this.$forceUpdate();
        
        this.emailInput = this.$el.querySelector('[type="email"]');
        const requiredInputs = this.$el.querySelectorAll('form [data-val-required]');
        for(const requiredInput of requiredInputs) {
                requiredInput.required = true;
                requiredInput.setAttribute('aria-required', 'true');
                requiredInput.setAttribute('aria-invalid', 'false');
                requiredInput.addEventListener('blur', () => {
                    if(requiredInput.validity.valid === false) {
                        if(requiredInput.nextElementSibling.classList.contains('field-validation-error')) {
                            requiredInput.nextElementSibling.style.display = 'block';
                        }
                        requiredInput.setAttribute('aria-invalid', 'true');
                    }
                });
        }
        this.form.addEventListener('input', () => {
            this.isValid = this.isFormValid();
            this.submitButton.disabled = !this.isValid;
          
        });
        this.submitButton.addEventListener('click', (e) => {
            //e.preventDefault(); // for testing
            
            this.onSubmitClicked();
        });

        document.addEventListener("sc-forms-submit-success", function(e) {
            
            
            /*setTimeout(function() {
                if(browser.mobile) {
                    // var _frm = document.getElementById(e.detail);
                    var _frm = document.querySelector('.c-aha-form');
                    var _parentFrm = _frm.closest('.container');
                    _parentFrm.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                    
                }
            }, 0);*/

        });

    }
}
</script>
<style>
.loader {
    font-size: 8px;
    position: relative;
    text-indent: -9999em;
    border-top: 0.75em solid pink;
    border-right: 0.75em solid pink;
    border-bottom: 0.75em solid pink;
    border-left: 0.75em solid #C10E21;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
}

.loader, .loader:after {
    border-radius: 50%;
    width: 5em;
    height: 5em;
}
</style>



// WEBPACK FOOTER //
// src/app/components/aha-sitecore-form-wrapper.vue